import React from "react";
import { Button } from "@material-ui/core";
import { connect } from "react-redux";
import { hasRoutePermission } from "shared/utils";

const PermissionButton = ({ role, route, permission, disabled, ...props }) => {
  const { dispatch, startIcon, ...rest } = props;
  const allow = hasRoutePermission(route, role, permission);

  const wrappedStartIcon = startIcon ? (
    <span
      style={{
        display: "inline-flex",
        opacity: allow ? 1 : 0.4,
        filter: allow ? "none" : "grayscale(100%)",
      }}
    >
      {startIcon}
    </span>
  ) : undefined;

  return (
    <Button
      variant="contained"
      className="shadow-none"
      color="primary"
      {...rest}
      startIcon={wrappedStartIcon}
      disabled={!allow || disabled}
    >
      {rest.children}
    </Button>
  );
};

const mapStateToProps = ({ role }) => ({
  role,
});

export default connect(mapStateToProps)(PermissionButton);